/** @jsxImportSource @emotion/react */
import { normalizeKey } from '@deity-io/di-data-basics';
import type { IField, ISchema } from 'contracts/interfaces';
import type React from 'react';
import { isCollection } from 'utils/isCollection';
import SchemaField from './SchemaField';

type SchemaContainerProps = {
  schema: ISchema;
  uuid: string;
  selectedField: Array<string>;
  locked?: boolean;
  handleFieldAction;
  validateKey;
  onSelect;
  name: string;
  packageVersionUuid: string;
};
/**
 * Placeholder for schemaField, but then in memo with calculated should upDate
 * Todo implement
 */
const SchemaMemo: React.FC<SchemaContainerProps> = ({
  uuid,
  packageVersionUuid,
  schema,
  selectedField,
  locked,
  handleFieldAction,
  validateKey,
  onSelect,
  name
}) => (
  <SchemaField
    path={[]}
    key={name}
    field={isCollection(schema) ? (schema._meta?.name as string) || normalizeKey(name) : normalizeKey(name)}
    isEditable={locked !== true}
    selectedField={selectedField}
    schema={schema as any as IField}
    onSelect={onSelect}
    onAction={handleFieldAction}
    validateKey={validateKey}
    packageVersionUuid={packageVersionUuid}
    source={{ uuid, schema, name, path: [] }}
  />
);
export default SchemaMemo;

// export default React.memo(SchemaMemo, (prevProps, nextProps) => {
//   const { schema: oldSchema, ...oldProps } = prevProps;
//   const { schema: newSchema, ...newProps } = nextProps;
//   // if (_.isEqual(oldProps, newProps)) {
//   //   return true;
//   // }
//   // console.log('todo memo compare', oldSchema, newSchema);
//   return true;
//   // return true;
// });
